import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/* eslint-disable max-len, react/prop-types */
var PinOutline = function PinOutline() {
  return /*#__PURE__*/_jsxs("svg", {
    "aria-hidden": "true",
    role: "presentation",
    viewBox: "0.8 0 62.52 90.1",
    children: [/*#__PURE__*/_jsx("title", {
      children: "Outline Pin Icon"
    }), /*#__PURE__*/_jsx("path", {
      d: "M32.1 5c9.8 0 18.7 5.4 23.2 14.1 2.3 4.5 3.3 9.3 2.8 14.5-.4 4.2-1.7 8.1-4.2 12.1C48 55 42.1 64.5 36.4 73.6c-1.5 2.4-3 4.7-4.4 7.1-.2-.3-.3-.6-.5-.8l-1.3-2.1c-5.7-9-11.5-18.3-17.3-27.5-1.9-3-3.4-5.5-4.7-8.2-1.9-3.8-2.6-8-2.3-12.7.6-7.6 3.8-13.7 9.7-18.5 4-3.2 8.4-5.1 13.7-5.7.9-.1 1.9-.2 2.8-.2Zm-.2 45c10.4 0 18.8-8.4 18.8-18.7 0-5-2-9.7-5.5-13.3-3.5-3.5-8.3-5.5-13.3-5.5s-9.7 2-13.2 5.5-5.5 8.2-5.5 13.2C13.3 41.5 21.6 50 31.9 50Zm.2-50c-1.1 0-2.2.1-3.4.2C22.6.8 17.1 3.1 12.4 7 5.4 12.7 1.6 20 .9 29c-.4 5.3.4 10.5 2.8 15.3 1.5 3 3.2 5.8 5 8.6l18.6 29.7c1.6 2.5 3.2 4.9 4.8 7.5.4-.6.7-1.1 1-1.5 8.4-13.4 16.7-26.7 25.1-40.1 2.8-4.4 4.6-9.1 5-14.3.5-6.1-.6-11.8-3.4-17.2-5.4-10.4-16-17-27.7-17ZM32 45c-7.5 0-13.7-6.2-13.7-13.8 0-7.5 6.2-13.7 13.7-13.7 7.6 0 13.8 6.2 13.8 13.8C45.8 38.8 39.6 45 32 45Z"
    })]
  });
};

export default PinOutline;